import React from "react";
import MuiTextField from "@mui/material/TextField";
import { textFieldProps } from "./fieldProps";

const INPUT_TYPE = { email: "email", tel: "tel" };
const AUTOCOMPLETE = { email: "email", tel: "tel" };
const INPUT_MODE = { email: "email", tel: "tel" };

/** `text` · `email` · `tel` — one line of text. */
export default function TextField(props) {
	const { field } = props;
	return (
		<MuiTextField
			{...textFieldProps(props)}
			type={INPUT_TYPE[field.type] || "text"}
			inputProps={{
				maxLength: field.maxLength,
				autoComplete: AUTOCOMPLETE[field.type],
				inputMode: INPUT_MODE[field.type],
			}}
		/>
	);
}
